import { Box, BoxProps, ColorOptions, IconNew as Icon, Spacer, TextNew as Text } from '@jfs/ui-new'
import { useCallback } from 'react'

const inputBoxConfig = {
  element: document.createElement('input'),
  type: 'file',
}

interface FileSelectorProps {
  onFileSelect: any
  onError: (err: string) => void
  mid: string
}

const FileSelector = ({ onFileSelect, mid, onError }: FileSelectorProps) => {
  const setData = useCallback(
    (name: string, fileSize: number, file: File) => onFileSelect(name, fileSize, file),
    [onFileSelect],
  )

  const onDragStart = (e: any) => {
    e.preventDefault()
  }

  const onDragOver = (e: any) => {
    e.preventDefault()
  }

  const onDrop = (e: any) => {
    e.preventDefault()
    const fileIn = (e.dataTransfer.files as FileList)[0]
    checkValidateProcessFile(fileIn, setData, e.target)
  }

  const isValidTodaysDate = (dateString: string) => {
    const today = new Date()
    const tMonth = today.getMonth() + 1
    const month = tMonth < 10 ? '0' + '' + tMonth : tMonth
    const tDay = today.getDate()
    const day = tDay < 10 ? '0' + '' + tDay : tDay
    const year = today.getFullYear()
    const date = year + '' + month + '' + day

    if (dateString.startsWith(date)) {
      dateString = dateString.slice(date.length)
      if (/(?:[01]\d|2[0123])(?:[012345]\d)(?:[012345]\d)/gm.test(dateString)) {
        return true
      }
    }
    return false
  }

  const isMidValid = (fileMid: string, midSelected: string) => {
    if (fileMid === midSelected) {
      return true
    }
    return false
  }

  const isFileNameFormatMatches = (filename: string) => {
    if (filename.lastIndexOf('.') !== -1) {
      filename = filename.substring(0, filename.lastIndexOf('.'))
      const fileNameParts = filename.split('_')
      if (fileNameParts.length > 2 && fileNameParts[0] === 'jfs') {
        return true
      }
    }
    return false
  }

  const checkValidateProcessFile = (fileChosen: File, setDataCallBack: any, event: any) => {
    if (fileChosen && fileChosen?.name) {
      const fileNameParts = fileChosen.name.split('_')
      if (!isValidTodaysDate(fileNameParts[1])) {
        onError("Please edit file name with today's date in the format as per sample file name")
      } else if (!isMidValid(fileNameParts[2], mid)) {
        onError('Please edit file name with selected MID as per sample file name')
      } else if (!isFileNameFormatMatches(fileChosen.name)) {
        onError('Please select file with jfs_yyyymmddhhmmss_mid_recordscount format')
      } else {
        // Check for filesize 5mb
        if (fileChosen && fileChosen.size < 5242880) {
          setDataCallBack(fileChosen?.name ?? '', fileChosen?.size ?? 0, fileChosen)
        } else {
          onError('File too huge, Please select a file with size <= 5MB')
        }
      }
    }
    if (event) {
      event.value = ''
    }
  }

  const selectFileButtonPressed = (): void => {
    const inputBox = inputBoxConfig.element
    inputBox.type = inputBoxConfig.type
    inputBox.accept = '.csv'
    inputBox.draggable = true
    inputBox.className = 'inputFileClass'
    inputBox.click()
    inputBox.onchange = (e: Event): void => {
      const target = e.target as HTMLInputElement
      const fileIn = (target.files as FileList)[0]
      checkValidateProcessFile(fileIn, setData, e.target)
    }
  }

  return (
    <div draggable={true} onDragStart={onDragStart} onDragOver={onDragOver} onDrop={onDrop}>
      <Box {...styles.container} onPress={selectFileButtonPressed} testID={'selectBulkRefundFileToUpload'}>
        <Box {...styles.addContainer}>
          <Icon id={'ADD'} color={'WHITE'} size={24} />
        </Box>
        <Spacer size={24} direction={'vertical'} />
        <Text fontFamily={'jiotype-medium'} fontSize={12} color={'BLACK_21'}>
          {'Drop your bulk refund file here (CSV file supported)'}
        </Text>
        <Spacer size={8} direction={'vertical'} />
        <Text fontFamily={'jiotype-medium'} fontSize={12} color={'PRIMARY_GREY'}>
          {'or'}
        </Text>
        <Spacer size={8} direction={'vertical'} />
        <Text fontFamily={'jiotype-medium'} fontSize={12} color={'BLUE'}>
          {'Browse file'}
        </Text>
      </Box>
      <Spacer size={16} direction={'vertical'} />
    </div>
  )
}

const styles = {
  container: {
    borderStyle: 'dashed',
    height: '240px',
    width: '700px',
    paddingHorizontal: 'MEDIUM',
    borderWidth: 1,
    borderRadius: '4px',
    borderColor: '#0186B080' as ColorOptions,
    disabled: false,
    underlayColor: 'WHITE',
    align: 'center',
    justify: 'center',
    bg: '#0186B00A' as ColorOptions,
  } as BoxProps,
  addContainer: {
    width: '72px',
    height: '72px',
    borderRadius: '36px',
    bg: 'BLUE',
    align: 'center',
    justify: 'center',
  } as BoxProps,
}

export { FileSelector }
